import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.18.1_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.17.2_@vue+compile_e1d85fa68d66967c9c95aea7addd2536/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/vercel/path0/node_modules/.pnpm/@una-ui+content@48.2.0_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.17.2_@_190e35a8537a9e6d224fc58c687a5574/node_modules/@una-ui/content/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}